export default {"src":"/_next/static/media/crowdpad.00a5d341.svg","height":32,"width":32};